import { clickGamePoint } from './browser-clicker'

export function executePoint(frame, point) {
  if (!frame || !frame.isConnected || !frame.getAttribute('src') && !frame.getAttribute('srcdoc')) throw new Error('请先进入游戏')
  const rect = frame.getBoundingClientRect()
  if (rect.width <= 0 || rect.height <= 0) throw new Error('游戏画面尚未就绪')
  if (window.androidJs && typeof window.androidJs.autoClick === 'function') {
    // Existing host API takes fractions of the whole WebView, including iframe offset.
    window.androidJs.autoClick((rect.left + point.x * rect.width) / window.innerWidth, (rect.top + point.y * rect.height) / window.innerHeight)
    return { native: true }
  }
  const result = clickGamePoint(frame, point)
  if (!result.ok) {
    const messages = { 'cross-origin': '此游戏需要在游戏包内使用连点', 'sensitive-target': '此位置不适合自动点击，请重新选点', 'no-target': '点位没有可点击内容', 'navigation': '游戏页面已变化，请重新开始', 'resize': '屏幕尺寸已变化，请重新确认点位' }
    throw new Error(messages[result.reason] || '当前游戏暂不支持浏览器连点')
  }
  return result
}
